import {useNeuroState} from "@ignitesales/neuro-application";

// DEVNOTE: Refer to dialogueGuideSettingsConfig in themeHelper.js for values that are configurable as dialogue guide settings
/**
 * @typedef DialogueGuideSettingsHookValues
 * @property {Boolean} isFdicMember - indicates if guide/client is FDIC Member
 * @property {Boolean} isEhlMember - indicates if guide/client is EHL Member
 * @property {Boolean} disableProductActions - indicates if product actions should be hidden
 * @property {String} contactType - contact form method
 * @property {Boolean} contactBeforeSummary - if true, contact method must be completed before products are shown
 * @property {Boolean} useTextResultsAction - if true, users are able to see button for texting results
 * @property {Boolean} useEmailResultsAction - if true, users are able to see email results button
 * @property {Boolean} shouldWarnOnClose - prompt user prior to exiting the guide
 * @property {Boolean} showEditAnswers - if true, users can click "Edit Answer" links on the summary page
 */

/**
 * Dialogue guide settings, configured in the dialogue portal
 * @returns {DialogueGuideSettingsHookValues}
 */
const useDialogueGuideSettings = () => {
    const { dialogueGuideSettings } = useNeuroState();

    return {
        ...dialogueGuideSettings
    };
};

export { useDialogueGuideSettings };
